import { create } from 'zustand';
import { apiGet } from '../lib/api-client';
import { showErrorToast } from './toastStore';
import type { DashboardData, DashboardFilters, DbStats } from '@range-reader/shared/api.types';

const DEFAULT_FILTERS: DashboardFilters = {
  dateFrom: null,
  dateTo: null,
  tableType: 'any',
  stakeLevel: 'any',
};

interface DashboardState {
  data: DashboardData | null;
  dbStats: DbStats | null;
  filters: DashboardFilters;
  loading: boolean;
  error: string | null;

  fetchData: () => Promise<void>;
  fetchDbStats: () => Promise<void>;
  setFilters: (filters: Partial<DashboardFilters>) => void;
}

export const useDashboardStore = create<DashboardState>((set, get) => ({
  data: null,
  dbStats: null,
  filters: DEFAULT_FILTERS,
  loading: false,
  error: null,

  fetchData: async () => {
    set({ loading: true, error: null });
    try {
      const data = await apiGet<DashboardData>('/api/stats/dashboard', {
        filters: JSON.stringify(get().filters),
      });
      set({ data, loading: false });
    } catch (e) {
      set({ error: String(e), loading: false });
    }
  },

  fetchDbStats: async () => {
    try {
      const dbStats = await apiGet<DbStats>('/api/stats/db');
      set({ dbStats });
    } catch (e) {
      console.error('Failed to fetch db stats:', e);
      showErrorToast('Failed to load database stats.');
    }
  },

  setFilters: (partial) => {
    set((s) => ({ filters: { ...s.filters, ...partial } }));
    get().fetchData();
  },
}));
